<template>
  <section class="overlay-alert">
    <div class="grid-container">
      <div class="col-4">
        <div class="alert-box">
          <h4>Block &amp; Report {{ firstname + ' ' + surname}}?</h4>
          <a class="btn-remove" @click="closeOverlay"></a>
          <div class="info">
            <p>
            <label>Tell us why you want to report {{ firstname }}:</label>
            <textarea rows="6" class="modal" v-model.trim="reportReason" :placeholder="'I want to report ' + firstname + ' because...'"></textarea>
            </p>
          </div>
          <div class="options">
            <a class="link-simple" @click="closeOverlay">Cancel</a>
            <a class="btn active" @click="reportUser">Block &amp; Report</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { db, auth } from '@/firebase'
import router from '@/router'

export default {
  props: ['userid', 'firstname', 'surname'],
  data () {
    return {
      reportReason: '',
      now: Date.now()
    }
  },
  methods: {
    closeOverlay () {
      this.$parent.showBlockOverlay = false
    },
    reportUser () {
      let user = auth.currentUser
      if (user) {
        // Add user to blocked users of that user
        db.ref('users/' + user.uid + '/blocked-users').update({
          [this.userid]: true
        })
        // Add to reports
        db.ref('reports/reported-users').push({
          reportedUser: this.userid,
          reason: this.reportReason,
          reportedBy: user.uid,
          when: this.now
        }, function () {
          router.push('/matches')
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// BlockReport.vue?64671811